import { InjectionToken } from '@angular/core';

export const S3OptionsService = new InjectionToken<{ bucket: string; region: string }>(undefined);
